import './bootstrap';
import createPrototypeViewer from './createPrototypeViewer';
import { addHotspots } from './updateProjectConfig';
import createStore from './utils/createStore';
export default function prototypeViewer(listeners, options) {
    if (options === void 0) { options = {}; }
    var store = createStore(undefined, listeners, options.isDownloaded, options.isAppBuild);
    return createPrototypeViewer(store, options);
}
export { addHotspots };
